import { render, staticRenderFns } from "./SpaceProp.vue?vue&type=template&id=ce3ccf4e&"
import script from "./SpaceProp.vue?vue&type=script&lang=js&"
export * from "./SpaceProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports